import React from 'react';

export interface AdelanteIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const AdelanteIcon: React.FC<AdelanteIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9.334 18.83 6-6-6-6"/>
    </svg>
  );
};

export default AdelanteIcon;
